import React, {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../../assets/MALogo.svg';

const ContributionPageError = ({status, message}) => {

  const navigate = useNavigate();

  const statuses = {
    401: "Unauthorized Access",
    // 404: "Not Found", // Not used for contributions but keep just in case
    406: "Not Acceptable",
    500: "Server Error"
  };

  const buttonType = {
    401: { text: "Sign In", action: () => navigate('/login') },
    // 404: { text: "Contribute", action: () => navigate('/pricing') },
    406: { text: "Verify Email", action: () => navigate('/profile') },
    500: { text: "Go Home", action: () => navigate('/') }
  }

  return (
    <div className='wrapper'>
      <div className='background-grid d-flex flex-column justify-content-center align-items-center' style={{minHeight: '100vh'}}>
        <div className='d-flex mb-2' style={{cursor: 'pointer'}} onClick={() => window.location.href='/'}>
            <img src={Logo} alt="Melee Academy Logo" style={{width: "50px", marginRight: "12px"}}/>
            <h2 style={{fontWeight: 600}}>Melee Academy</h2>
        </div>
        {status && <h5>{status}: {statuses[status]}</h5>}
        {message && <p className='text-center px-5' style={{fontWeight: 300}}>{message}</p>}
        {status &&
          <button
            className='rounded mt-3'
            style={{backgroundColor: '#FFCC19', height: "45px", fontWeight: 600, width: "200px", border: "none", color: "black"}}
            onClick={buttonType[status]?.action}
          >
            {buttonType[status]?.text}
          </button>
        }
      </div>
    </div>
  );
};

export default ContributionPageError;